export default "__VITE_ASSET__zYWYpIdA__"